<template>
<div class="classes">
  <h1 class="title grey--text">班级列表</h1>
  <v-container class="my-5">
    <v-layout justify-center class="pa3">
      <v-flex xs12 sm10 md8>
        <v-select
          v-model="programIds"
          :items="programs"
          item-text="title"
          item-value="program_id"
          label="所选项目"
          chips
          multiple
          prepend-icon="ballot"
          menu-props="offsetY"
          @change="updateClasses"
        ></v-select>
      </v-flex>
    </v-layout>

    <v-layout justify-center class="mb-2">
      <v-flex class="d-flex justify-center">
        <v-btn
          text
          outlined
          disabled
          @click="$router.push({ name: 'create-class'})">
          <v-icon>add</v-icon>
          创建班级
        </v-btn>
      </v-flex>
    </v-layout>

    <v-card
      v-for="(singleClass, indexClass) in classesShow" v-bind:key="`class-${indexClass}`"
      :class="`my-5 classes class-status-code-${singleClass.status_code}`"
    >
      <v-layout column >
        <div class="px-5 pt-5">
          <v-flex>
            <div class="title font-weight-bold">{{ singleClass.class }}</div>
          </v-flex>
          <v-flex>
            <div class="caption grey--text">描述</div>
            <div class="subtitle-2">{{ singleClass.description }}</div>
          </v-flex>
          <v-flex>
            <div class="caption grey--text">场地</div>
            <div class="subtitle-2">{{ singleClass.venue }}</div>
          </v-flex>
          <v-flex>
            <div class="caption grey--text">状态</div>
            <div class="subtitle-2">{{ singleClass.status }}</div>
          </v-flex>
        </div>
        <v-divider class="mt-3"></v-divider>
        <v-flex class="d-flex justify-center" @click="getClassDetails(indexClass)">
          <v-btn text block small tile>
            <span class="caption grey--text">{{singleClass.show ? '收起' : '展开'}}班级详情</span>
            <v-icon>{{ singleClass.show ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
          </v-btn>
        </v-flex>
        <v-flex>
          <v-slide-y-transition>
            <v-card-text v-show="singleClass.show" class="grey--text">

              <div class="mb-3">
                <v-subheader> 所属项目 </v-subheader>
                <v-icon>ballot</v-icon> 项目>{{ singleClass.program }} |
                <v-icon>person</v-icon> 教师>{{ singleClass.tutor }}
              </div>

              <v-divider></v-divider>

              <div class="mb-3">
                <v-subheader> 场地承接 <v-btn text icon color="grey"><v-icon>edit</v-icon></v-btn></v-subheader>
                <v-icon>person_outline</v-icon> 承接>
                <span
                  :style="{ cursor: 'pointer'}"
                  @click="$router.push({
                    name: 'host-income',
                    params:{
                      hostId: singleClass.host_id,
                    }
                  })"
                >
                  {{ singleClass.host }}
                </span> |
                <v-icon>store</v-icon> 场地>{{ singleClass.venue_description }}

                <v-dialog v-model="singleClass.venueAssignmentRemovalDialog" max-width="600px" right>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      delete
                    </v-icon>
                  </template>

                  <v-card>
                    <v-card-title>
                      <span class="headline">取消场地承接</span>
                    </v-card-title>

                    <v-card-text>
                      <p> 确认取消 {{ singleClass.venue_description }} 承接本班 ({{ singleClass.class }}) 活动? </p>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text @click="singleClass.venueAssignmentRemovalDialog = false">关闭</v-btn>
                      <v-btn color="warning" @click="venueAssignmentRemoval(singleClass.class_id, singleClass.venue_id, indexClass)">删除</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

              <v-divider></v-divider>

              <div class="mb-3">
                <v-subheader>
                  班级学员
                  <v-dialog v-model="singleClass.studentEnrollmentDialog" max-width="600px">
                    <template v-slot:activator="{ on }">
                      <v-btn text icon color="grey" v-on="on" @click="studentClassEnrollInit(indexClass)">
                        <v-icon>
                          group_add
                        </v-icon>
                      </v-btn>
                    </template>

                    <v-card>
                      <v-card-title>
                        <span class="headline">增加学员</span>
                      </v-card-title>

                      <v-card-text>
                        <p>请选择需要增加的学员</p>
                        <div v-for="(unenrolledStudent, indexUnenrolledStudent) in unenrolledStudents" v-bind:key="`unenrolledStudent-${indexUnenrolledStudent}`">
                          <v-checkbox :v-if="`${unenrolledStudent.program_id == singleClass.program_id}`"
                            v-model="unenrolledStudentIdsSelected"
                            :label="`${unenrolledStudent.student_name} (课时：${unenrolledStudent.lesson_quantity})`"
                            :value="`${unenrolledStudent.student_id}`">
                          </v-checkbox>
                        </div>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="singleClass.studentEnrollmentDialog = false">取消</v-btn>
                        <v-btn color="success" @click="studentClassEnroll(unenrolledStudentIdsSelected, singleClass.class_id, indexClass)">确定</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-subheader>
                <span v-for="(student, indexStudent) in singleClass.students" v-bind:key="`student-${indexStudent}`">
                  <v-chip
                    :color="`${student.sex == 'M' ? 'blue lighten-3': 'pink lighten-2'}`"
                    text-color="white"
                    class="ma-1"
                  >
                    <v-avatar
                      :class="`${student.lesson_quantity - student.unfinalizedLessonUsageQuantity > 10 ? 'green' : 'red'}`"
                      left
                      @click="$router.push({
                        name: 'student-details',
                        params:{
                          studentId: student.student_id,
                          programId: singleClass.program_id
                        }
                      })"
                    >
                      {{ student.lesson_quantity }}
                    </v-avatar>
                    {{student.unfinalizedLessonUsageQuantity > 0 ? `(待结:${student.unfinalizedLessonUsageQuantity}) ` : ''}}{{ student.student_name }}
                    <v-dialog v-model="student.studentDisenrollmentDialog" max-width="600px" right>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">
                          clear
                        </v-icon>
                      </template>

                      <v-card>
                        <v-card-title>
                          <span class="headline">移除学员</span>
                        </v-card-title>

                        <v-card-text>
                          <p> 确认将学员 {{ student.student_name }} 移除本班({{ singleClass.class }})? </p>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn text @click="student.studentDisenrollmentDialog = false">关闭</v-btn>
                          <v-btn color="warning" @click="studentClassDisenrollment(student.student_id, student.class_id, indexClass, indexStudent)">删除</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-chip>
                </span>
              </div>

              <v-divider></v-divider>

              <div>
                <v-subheader> 其它操作 </v-subheader>

                <v-dialog v-model="singleClass.editClassStatusDialog" max-width="600px">
                  <template v-slot:activator="{ on }">
                    <v-btn text v-on="on" color="info"
                      @click="editClassStatusInit(indexClass)"
                    >
                      修改本班状态
                      <v-icon>
                        edit_attributes
                      </v-icon>
                    </v-btn>
                  </template>

                  <v-card>
                    <v-card-title>
                      <span class="headline">修改班级状态</span>
                    </v-card-title>

                    <v-card-text>
                      <v-radio-group v-model="singleClass.status_code" :mandatory="false">
                        <div v-for="(classStatusItem, indexClassStatusItem) in classStatusItems" v-bind:key="`classStatusItem-${indexClassStatusItem}`">
                          <v-radio :label="classStatusItem.status" :value="classStatusItem.code"></v-radio>
                        </div>
                      </v-radio-group>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text @click="singleClass.editClassStatusDialog = false">取消</v-btn>
                      <v-btn color="warning" @click="updateClassStatus(singleClass.class_id, singleClass.status_code, indexClass)">确定</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="singleClass.deleteClassDialog" max-width="600px">
                  <template v-slot:activator="{ on }">
                    <v-btn text v-on="on" color="error"
                      @click="singleClass.deleteClassDialog = true"
                      :disabled="singleClass.students.length > 0"
                    >
                      删除
                      <v-icon>
                        delete
                      </v-icon>
                    </v-btn>
                  </template>

                  <v-card>
                    <v-card-title>
                      <span class="headline">删除班级</span>
                    </v-card-title>

                    <v-card-text>
                      <p>确定删除班级：{{ singleClass.class }}</p>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text @click="singleClass.deleteClassDialog = false">取消</v-btn>
                      <v-btn color="warning" @click="deleteClass(singleClass.class_id, indexClass)">确定</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

              </div>
            </v-card-text>
          </v-slide-y-transition>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
    </v-card>
  </v-container>
</div>
</template>

<script>
import ProgramService from '@/services/ProgramService'
import Vue from 'vue'
import { inArray } from '@/lib/helper'

export default {
  components: {
  },
  data () {
    return {
      programs: [],
      programIds: [],
      programClasses: [],
      classesShow: [],
      unenrolledStudents: [],
      unenrolledStudentIdsSelected: [],
      classStatusItems: []
    }
  },
  async mounted () {
    // set queryingState
    this.$store.dispatch('setQueryingState', true)

    if (this.$store.state.account.organizationGroupManager.organizationGroups.length > 0) {
      const organizationGroups = this.$store.state.account.organizationGroupManager.organizationGroups
      const organizationGroupIds = organizationGroups.map(organizationGroup => organizationGroup.organization_group_id)
      // get programs
      this.$store.dispatch('setQueryingState', true)
      const res = await ProgramService.getCategorizedPrograms({ organizationGroupIds, isPublished: true, isDraft: true, isPending: true, isClosed: true })
      this.programs = this.programs.concat(res.data.publishedPrograms, res.data.draftPrograms, res.data.pendingPrograms, res.data.closedPrograms)
    }

    // Initialize programIds to include all classes under the organization
    this.programs.forEach((program) => {
      if (program.status_code > 0) {
        this.programIds.push(program.program_id)
      }
    })

    // refresh classInfo
    this.refreshClassInfo()

    // set queryingState
    this.$store.dispatch('setQueryingState', false)
  },
  methods: {
    async refreshClassInfo () { // done
      // get classes by program Id
      this.programClasses = await this.getClassesByProgramId(this.programIds)
      // add show property
      this.programClasses.forEach(element => {
        Vue.set(element, 'show', false) // Use vue.set to dynamically add properties to object and make it reactive
        Vue.set(element, 'students', [])
        Vue.set(element, 'studentEnrollmentDialog', false)
        Vue.set(element, 'deleteClassDialog', false)
        Vue.set(element, 'editClassStatusDialog', false)
        Vue.set(element, 'venueAssignmentRemovalDialog', false)
      })
      // set classesShow for display
      this.classesShow = this.programClasses
    },
    async getClassesByProgramId (programIds) { // done
      const res = await ProgramService.getClasses({ programIds })
      console.log('programIds:', programIds, 'Retreving programs successfully: ', res.data.classes)
      return res.data
    },
    async getClassDetails (arrayIndex) { // done
      const classId = this.classesShow[arrayIndex].class_id
      console.log('\nThe "detail" button is clicked! classId: ', classId)
      console.log('classesShow[arrayIndex]: ', this.classesShow[arrayIndex])
      this.classesShow[arrayIndex].show = !this.classesShow[arrayIndex].show

      if (this.classesShow[arrayIndex].students.length === 0) {
        const students = await this.getStudentsByClassId(classId)
        students.forEach(student => {
          Vue.set(student, 'studentDisenrollmentDialog', false)
        })
        this.classesShow[arrayIndex].students = students
        console.log('classesShow[arrayIndex]: ', this.classesShow[arrayIndex])
      }
    },
    async getStudentsByClassId (classId) { // done
      console.log('\ngetStudentsByClassId start, classId: ', classId)
      console.log('query send, waiting for server response ... ')
      const res = await ProgramService.getStudents({ classIds: [classId] })
      const classStudents = res.data
      console.log('Retrieved students: ', classStudents)
      return classStudents
    },
    async studentClassDisenrollment (studentId, classId, indexClass, indexStudent) { // done
      console.log('\n#studentClassDisenrollment start ... \nConfirming to disenroll student (studentId: ', studentId, ') from class (classId: ', classId, ')')
      await ProgramService.studentClassDisenrollment(studentId, classId)
      this.classesShow[indexClass].students[indexStudent].studentDisenrollmentDialog = false
      const students = await this.getStudentsByClassId(classId)
      students.forEach(student => {
        Vue.set(student, 'studentDisenrollmentDialog', false)
      })
      this.classesShow[indexClass].students = students
    },
    async studentClassEnrollInit (indexClass) { // done
      console.log('\nstudentClassEnrollInit start ... \nRetrieve unenrolled students information under current program ... ')
      // Retrieve unenrolled students information under current program
      const programId = this.classesShow[indexClass].program_id
      const res = await ProgramService.getStudents({ programIds: [programId] })
      const students = res.data
      if (students.length > 0) {
        const enrollmentStatusCodes = [0, 2, 3, null]
        console.log(`retrieve all students under program: ${students}, filter using enrollmentSatusCodes: ${enrollmentStatusCodes}`)
        this.unenrolledStudents = students.filter((student) => {
          let show = false
          show = inArray(student.enrollment_status_code, enrollmentStatusCodes) && student.lesson_quantity > 0
          return show
        })
        console.log('unenrolledStudents (programId: ', this.programIds, '): ', this.unenrolledStudents)
        this.classesShow[indexClass].studentEnrollmentDialog = true
      }
    },
    async studentClassEnroll (studentIds, classId, indexClass) { // done TO-DO: unenrolledStudentIdsSelected sometimes might change into var not [], this will make enrollment failure (but if user try multiple times it will work)
      console.log('\nstudentClassEnroll initiated ...')
      console.log('\nstudentId: ', studentIds, '\nclassId: ', classId)
      console.log('\nStart to enroll ...')
      const response = await ProgramService.studentClassEnroll(studentIds, classId)
      const studentClassEnrollmenteIds = response.data
      console.log('\nEnrollment successful! studentClassEnrollmenteIds: ', studentClassEnrollmenteIds)
      this.classesShow[indexClass].studentEnrollmentDialog = false
      this.unenrolledStudentIdsSelected = []
      console.log('\nRefreshing the enrolled student')
      const students = await this.getStudentsByClassId(classId)
      students.forEach(student => {
        Vue.set(student, 'studentDisenrollmentDialog', false)
      })
      this.classesShow[indexClass].students = students
    },
    async editClassStatusInit (indexClass) { // done
      // get class status
      if (this.classStatusItems.length < 3) { // classStatusItems hasn't been retrieved
        console.log('Retrieving class status items ... ')
        const res = await ProgramService.getClassStatusItems()
        this.classStatusItems = res.data
        console.log('Success! classStatusItems: ', this.classStatusItems)
      }
      // open the dialog
      this.classesShow[indexClass].editClassStatusDialog = true
    },
    async updateClassStatus (classId, statusCode, indexClass) { // done
      await ProgramService.updateClassStatus(classId, statusCode)
      // refresh classInfo
      this.refreshClassInfo()
      // close the dialog
      this.classesShow[indexClass].editClassStatusDialog = false
    },
    async updateClasses () {
      console.log('Input event triggered! programeIds: ', this.programIds)

      // set queryingState
      this.$store.dispatch('setQueryingState', true)

      // update classes
      console.log('Begin updating the classesShow ...')
      // const self = this
      this.classesShow = this.programClasses.filter(function (singleClass) {
        console.log('singleClass.program_id: ', singleClass.program_id)
        return this.programIds.indexOf(singleClass.program_id) >= 0
      })
      console.log('this.classesShow: ', this.classesShow)

      // set queryingState
      this.$store.dispatch('setQueryingState', false)
    },
    async deleteClass (classId, indexClass) {
      console.log('Class (id: ', classId, ') deletion with initiated ... ')
      console.log('\nCheck class enrolled students ... ')
      const students = await this.getStudentsByClassId(classId)
      console.log('Number of students: ', students.length)
      console.log('\nCheck class assigned venue ... ')
      const venue = await this.getVenueByClassId(classId)
      console.log('Class is assigned a venue: ', venue.length > 0)
      if (students.length === 0 && venue.length === 0) { // no students nor venue associated with class, ready for deletion
        console.log('\nClass is ready for deletion, proceed ...')
        await ProgramService.deleteClass(classId)
      } else { // either there are students and / or venue associated with class
        console.log('Can\'t delete class! There are students and / or venue associated with this class!')
      }
      this.classesShow[indexClass].deleteClassDialog = false
      // refresh classInfo
      this.refreshClassInfo()
    },
    async getVenueByClassId (classId) {
      console.log('\ngetVenueByClassId starts ... ')
      const res = await ProgramService.getVenueByClassId(classId)
      return res.data.venueInfo
    },

    async venueAssignmentRemoval (classId, venueId, indexClass) {
      console.log('\n venueAssignmentRemovalDialog starts ... ')
      await ProgramService.venueAssignmentRemoval(classId, venueId)
      console.log('\n Successful! Refreshing class infomation ... ')
      // refresh classInfo
      this.refreshClassInfo()
      // close the dialog
      this.classesShow[indexClass].venueAssignmentRemovalDialog = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.classes.class-status-code-1 {
  border-left: 4px solid #3cd1c3;
}
.classes.class-status-code-0 {
  border-left: 4px solid tomato;
}
.classes.class-status-code-2 {
  border-left: 4px solid orange;
}
</style>
